import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button3D } from '@/components/ui/button-3d';
import { UserPlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SignUpModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SignUpModal({ open, onOpenChange }: SignUpModalProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center items-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <UserPlus className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-xl text-center w-full">Crie sua conta grátis</DialogTitle>
          <DialogDescription className="text-center">
            Você já criou 1 orçamento como visitante. Para continuar criando orçamentos e não perder seu trabalho, crie uma conta gratuita.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 pt-4">
          <Button3D
            className="w-full"
            onClick={() => {
              onOpenChange(false);
              navigate('/auth?tab=signup');
            }}
          >
            Criar conta grátis
          </Button3D>
          <Button3D
            color="gray"
            className="w-full"
            onClick={() => onOpenChange(false)}
          >
            Continuar depois
          </Button3D>
        </div>
      </DialogContent>
    </Dialog>
  );
}
